import * as React from "react";

import "./browse-layout.scss";

import {TemplateFilters}  from "./template-filters/template-filters";
import {TemplatesGrid}    from "./templates-grid/templates-grid";
import {useSearchFilters} from "./use-search-filters";

export const BrowseLayout = ({
    addSearchHistoryRecord,
    agentBenefits,
    agentHasYearlySubscription,
    paywallModal,
    queryParam,
    templateDownloadModal,
    templates,
    userLevels,
}) => {
    const {
        clearFilterConfigs,
        filterConfigs,
        filters,
        getOptionCounts,
        mapResultSet,
        setFilterConfig,
    } = useSearchFilters(queryParam);

    // apply our filters
    const filteredTemplates = React.useMemo(
        () => mapResultSet(templates),
        [templates, mapResultSet]
    );

    return (
        <div className="browse-drvn9">
            <div className="header filters-section">
                <TemplateFilters
                    clearFilters={clearFilterConfigs}
                    filters={filters}
                    filterConfigs={filterConfigs}
                    getOptionCounts={getOptionCounts}
                    resultSet={templates}
                    setFilterConfig={setFilterConfig}
                />
            </div>
            <div className="header grid-section">
                <TemplatesGrid
                    addSearchHistoryRecord={addSearchHistoryRecord}
                    agentBenefits={agentBenefits}
                    agentHasYearlySubscription={agentHasYearlySubscription}
                    paywallModal={paywallModal}
                    templateDownloadModal={templateDownloadModal}
                    templates={filteredTemplates}
                    userLevels={userLevels}
                />
            </div>
        </div>
    );
};

